import "../style.css";
import "./getAllImagefromcloud.css";
import {
  React,
  useState,
  Box,
  Modal,
  styled,
  Paper,
  Grid,
  DeleteOutlineIcon,
  OfflinePinIcon,
  RemoveDoneIcon,
  memo,
  Pagination,
} from "../../../Libraries/Media/index";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { alpha } from "@mui/material/styles";
import ImageLazyLoading from "../../ImageLazyLoad/ImageLazyLoading";
import Dropzone from "../../ReactDropZone/FileUploadUsingDropZone";
import { truncateString } from "../../../Utils/stringtruncation";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const GetAllImagesFromCloud = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedImage, setSelectedImage] = useState();

  const [data, setdata] = useState({
    ImageUrl: null,
    open: false,
  });

  const handleOpenImage = (img) => {
    setAnchorEl(null);
    setdata((previousvalue) => ({
      ...previousvalue,
      ImageUrl: img.txt_media_streaming_link,
      open: true,
    }));
  };

  const closeMoal = () => {
    setdata((previousvalue) => ({
      ...previousvalue,
      open: false,
    }));
  };

  const handleClick = (event, media) => {
    setAnchorEl(event.currentTarget);
    setSelectedImage(media);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const itemsPerPage = 8;

  const handlePageChange = (index) => {
    setPageNumber(index);
  };

  const displayBulletins = props?.images
    ?.slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage)
    .map((image, index) => {
      return (
        <Grid item xs={12} md={4} lg={3} key={index}>
          <Item
            style={{
              borderRadius: "0px",
            }}
          >
            <div onClick={() => handleOpenImage(image)}>
              <ImageLazyLoading
                src={image.txt_media_streaming_link}
                alt={"img"}
                width={"100%"}
                height={"200px"}
                style={{ borderRadius: "8px", border: "3px solid #F0F0F0" }}
              />
            </div>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mt={1}
            >
              <span>{truncateString(image.txt_media_full_name, 8)}</span>
              <Box
                flexGrow={1}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={1}
              >
                <span>{image.media_size}</span>
                <div onClick={(e) => handleClick(e, image)}>
                  <MoreVertIcon />
                </div>
              </Box>
            </Box>
          </Item>
        </Grid>
      );
    });

  const pageCount = Math.ceil(props?.images?.length / itemsPerPage);

  return (
    <>
      {displayBulletins?.length > 0 ? (
        <>
          <Box
            sx={{ flexGrow: 1, marginBottom: 2 }}
            id="images"
            className="images"
          >
            <Grid container spacing={2}>
              {displayBulletins}
              <StyledMenu
                id="media-more-option"
                MenuListProps={{
                  "aria-labelledby": "media-more-option",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  disableRipple
                  onClick={() => {
                    props?.handleEnquireMedia(selectedImage);
                    setAnchorEl(null);
                  }}
                >
                  <DeleteOutlineIcon />
                  Delete
                </MenuItem>
                {/* <MenuItem
                  disableRipple
                  onClick={() => {
                    props?.handleMediaAsOffline(selectedImage);
                    setAnchorEl(null);
                  }}
                >
                  <div>
                    {selectedImage?.is_offline_available === false ? (
                      <>
                        <OfflinePinIcon />
                        Offline
                      </>
                    ) : selectedImage?.is_offline_available === true ? (
                      <>
                        <RemoveDoneIcon />
                        Online
                      </>
                    ) : null}
                  </div>
                </MenuItem> */}
              </StyledMenu>
            </Grid>
          </Box>

          <Pagination
            count={pageCount}
            color="primary"
            onChange={(event, value) => handlePageChange(value)}
            page={pageNumber}
          />
        </>
      ) : (
        <Dropzone
          getAllMediaFunc={props?.getAllMediaFunc}
          handleIndexChange={props?.handleIndexChange}
        />
      )}
      <Modal
        open={data?.open}
        onClose={closeMoal}
        classNames={{
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            height: "70vh",
            padding: "unset",
            overflow: "hidden",
            borderRadius: "8px",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
            borderRadius: "50%",
          },
        }}
        center
      >
        <ImageLazyLoading
          src={data?.ImageUrl}
          alt="img"
          width="100%"
          height="100%"
        />
      </Modal>
    </>
  );
};

export default memo(GetAllImagesFromCloud);
